import { render, staticRenderFns } from "./navigation-menu.vue?vue&type=template&id=e6378108&lang=pug&"
import script from "./navigation-menu.vue?vue&type=script&lang=ts&"
export * from "./navigation-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports